import { render, staticRenderFns } from "./CompraEdit.vue?vue&type=template&id=42de1596&scoped=true&"
import script from "./CompraEdit.vue?vue&type=script&lang=js&"
export * from "./CompraEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompraEdit.vue?vue&type=style&index=0&id=42de1596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de1596",
  null
  
)

export default component.exports